import { IoFilter, IoRefresh } from "react-icons/io5";
import { FaPeopleGroup } from "react-icons/fa6";
import { useLeadFilters } from "@/modules/leads/hooks/useLeadFilters";
// DashboardHeader.tsx
interface DashboardHeaderProps {
  companyName: string;
  onOpenFilter: () => void;
  isRefreshing?: boolean;
  onFullscreen?: () => void;
  isFullscreen?: boolean;
  refetch: () => void;
}

export function DashboardHeader({
  companyName,
  onOpenFilter,
  onFullscreen,
  isFullscreen = false,
  refetch,
}: DashboardHeaderProps) {
  const { applyFilters, isFiltering } = useLeadFilters();

  const handleRefetch = () => {
    applyFilters(refetch)
  }

  return (
    <div className="p-4 sm:p-6 bg-white pt-4 flex flex-col sm:flex-row sm:justify-between sm:items-center gap-4 mb-6 sm:mb-8 pb-4 border-b border-gray-200">
      <div className="flex flex-col justify-center items-start">
        <h1 className="text-xl sm:text-2xl font-semibold flex items-center gap-2 text-black">
          <FaPeopleGroup
            onClick={onFullscreen} // ✅ Usar a prop
            className={`w-6 h-6 sm:w-8 sm:h-8 text-locavibe flex-shrink-0 cursor-pointer transition-colors ${
              isFullscreen ? "text-green-600" : "hover:text-orange-600"
            }`}
            title={isFullscreen ? "Sair da tela cheia" : "Entrar em tela cheia"}
          />
          <span className="leading-tight">
            Dashboard Comercial
            <span className="block sm:inline sm:ml-1 text-gray-600 text-base sm:text-xl">
              {companyName}
            </span>
          </span>
        </h1>
      </div>

      {/* Botões de ação */}
      <div className="flex items-center gap-3">
        {/* Botão Refresh */}
        <button
          onClick={() => handleRefetch()}
          disabled={isFiltering}
          className="bg-white border border-gray-300 text-gray-700 px-4 py-2 rounded-lg hover:bg-gray-50 hover:border-gray-400 transition-all flex items-center gap-2 shadow-sm disabled:opacity-50"
        >
          <IoRefresh
            className={`text-lg ${isFiltering ? "animate-spin" : ""}`}
          />
          <span className="font-medium">Atualizar</span>
        </button>

        {/* Botão Filtrar */}
        <button
          onClick={onOpenFilter}
          className="bg-white border border-gray-300 text-gray-700 px-4 py-2 rounded-lg hover:bg-gray-50 hover:border-gray-400 transition-all flex items-center gap-2 shadow-sm"
        >
          <IoFilter className="text-lg" />
          <span className="font-medium">Filtrar</span>
        </button>
      </div>
    </div>
  );
}
